import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_title" }
const _hoisted_3 = { class: "area_button" }
const _hoisted_4 = { class: "area_body" }
const _hoisted_5 = { class: "area_section" }
const _hoisted_6 = { class: "area_search" }
const _hoisted_7 = { class: "select-wrap" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  class: "select-wrap"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "area_button" }
const _hoisted_13 = { class: "area_section" }
const _hoisted_14 = { class: "area_table" }
const _hoisted_15 = { class: "area_table_head" }
const _hoisted_16 = { class: "select-wrap" }
const _hoisted_17 = { class: "total_length" }
const _hoisted_18 = { class: "area_table_body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[16] || (_cache[16] = _createElementVNode("p", null, "민원", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.downloadFile && $setup.downloadFile(...args)))
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("img", { src: "img/excel.png" }, null, -1),
              _createElementVNode("span", null, "Excel 다운", -1)
            ]))]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({ name: 'complainAdd' })))
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("span", null, "등록", -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[20] || (_cache[20] = _createElementVNode("label", null, "검색조건", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("select", {
                      name: "searchType",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.searchType1) = $event))
                    }, [
                      _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchCondition, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key
                        }, _toDisplayString(item.name), 9, _hoisted_8))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, $setup.state.searchType1]
                    ])
                  ]),
                  ($setup.state.searchType1 !== 'complainantType' && $setup.state.searchType1 !== 'resultType')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        name: "searchText",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.searchText1) = $event)),
                        placeholder: "검색어를 입력해주세요.",
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => ($setup.fnGetList(1)), ["enter"]))
                      }, null, 544)), [
                        [_vModelText, $setup.state.searchText1]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        ($setup.state.searchType1 === 'complainantType')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              name: "searchType",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.searchText1) = $event)),
                              onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.fnGetList(1)))
                            }, [
                              _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.complainantTypeList, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key
                                }, _toDisplayString(item.name), 9, _hoisted_10))
                              }), 256))
                            ], 544)), [
                              [_vModelSelect, $setup.state.searchText1]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 1,
                              name: "searchType",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.searchText1) = $event)),
                              onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.fnGetList(1)))
                            }, [
                              _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.resultTypeList, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key
                                }, _toDisplayString(item.name), 9, _hoisted_11))
                              }), 256))
                            ], 544)), [
                              [_vModelSelect, $setup.state.searchText1]
                            ])
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                    $setup.reset();
                                    $setup.fnGetList(1);
                                })
                }, " 초기화 "),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.fnGetList(1)))
                }, "검색")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    name: "orderType",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.state.order) = $event)),
                    onChange: _cache[12] || (_cache[12] = ($event: any) => ($setup.fnGetList(1)))
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("option", { value: "0" }, "최근순", -1),
                    _createElementVNode("option", { value: "1" }, "과거순", -1)
                  ]))], 544), [
                    [_vModelSelect, $setup.state.order]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("notice.total")) + " : " + _toDisplayString($setup.CommonUtils.numberFormat($setup.pageState.length)) + " " + _toDisplayString(_ctx.$t("notice.count")), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_DataGrid, {
                  list: $setup.pageState.list,
                  columns: $setup.pageState.fields,
                  totalLength: $setup.pageState.length,
                  perPage: $setup.pageState.perPage,
                  cntPage: $setup.pageState.cntPage,
                  "current-page": $setup.pageState.currentPage,
                  isLoading: $setup.pageState.isLoading,
                  onOnRowClick: $setup.fnRowClick,
                  onOnPaging: $setup.fnGetList,
                  onOnNextPage: $setup.fnGoPage,
                  onOnPrevPage: $setup.fnGoPage,
                  onOnFirstPage: $setup.fnGoPage,
                  onOnLastPage: $setup.fnGoPage
                }, null, 8, ["list", "columns", "totalLength", "perPage", "cntPage", "current-page", "isLoading", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage"])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          "is-full-page": true
        }))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.isShowModal = false))
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}